import React, { useState, useRef, useEffect } from 'react';
import { ChevronDownIcon, CheckIcon } from '@heroicons/react/24/outline';

const ServiceTypeStep = ({ serviceTypes, selectedService, onSelect, isDesktop = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedServiceData = serviceTypes.find(s => s.id === selectedService);

  const handleSelect = (serviceId) => {
    onSelect(serviceId);
    setIsOpen(false);
  };

  return (
    <div className={`${isDesktop ? '' : 'max-w-md mx-auto'}`}>
      {!isDesktop && (
        <h3 className="mb-3 font-medium text-gray-800 dark:text-gray-100 text-base">
          Tipul Serviciului
        </h3>
      )}
      
      <div className="relative" ref={dropdownRef}>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-3 text-left shadow-sm hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {selectedServiceData ? (
                <>
                  <selectedServiceData.icon className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                  <span className="text-gray-900 dark:text-gray-100 font-medium">
                    {selectedServiceData.name}
                  </span>
                </>
              ) : (
                <span className="text-gray-500 dark:text-gray-400">
                  Selectează tipul de service
                </span>
              )}
            </div>
            <ChevronDownIcon 
              className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
                isOpen ? 'rotate-180' : ''
              }`} 
            />
          </div>
        </button>

        {isOpen && (
          <div className="absolute z-30 w-full mt-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl">
            <div className="py-2 max-h-60 overflow-y-auto">
              {serviceTypes.map((service) => (
                <button
                  key={service.id}
                  onClick={() => handleSelect(service.id)}
                  className="w-full px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 flex items-center justify-between group"
                >
                  <div className="flex items-center gap-3">
                    <service.icon className="h-5 w-5 text-gray-600 dark:text-gray-400 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors" />
                    <span className="text-gray-900 dark:text-gray-100 font-medium">
                      {service.name}
                    </span>
                  </div>
                  {selectedService === service.id && (
                    <CheckIcon className="h-5 w-5 text-purple-600 dark:text-purple-400" />
                  )}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceTypeStep;
